//
// Product
//
$('body.product').scrollspy({ target: '#section-navigation', offset: 60 });
$(window).on('activate.bs.scrollspy', function (e, obj) {
    var activeNavItem = $('#section-navigation .nav-link.active').first().closest('.nav-item');
    if (activeNavItem) {
        scrollItemToCenter(activeNavItem, '.product-section-navigation');
    }
});

$('.product-section-navigation-wrap button').on('click', function() {
    $('.product-section-navigation').animate({scrollLeft: 200}, 250);
});

function scrollItemToCenter(target, outer){
    var out = $(outer);
    var tar = $(target);
    var x = out.width();
    var y = tar.outerWidth(true);
    var z = tar.index();
    var q = 0;
    var m = out.find('li');
    //Just need to add up the width of all the elements before our target.
    for(var i = 0; i < z; i++){
        q+= $(m[i]).outerWidth(true);
    }
    var calcScrollLeft = Math.max(0, q - (x - y)/2);
    out.animate({scrollLeft: calcScrollLeft}, 250);
}

// Detect When a Sticky Element Gets Pinned
const sectionNavigation = document.querySelector("#section-navigation");
if (sectionNavigation) {
    const observer = new IntersectionObserver( 
        ([e]) => e.target.getBoundingClientRect().top <= 0 ? e.target.classList.add("is-pinned", e.intersectionRatio < 1) : e.target.classList.remove("is-pinned", e.intersectionRatio < 1),
        { threshold: [1] }
    );
    observer.observe(sectionNavigation);
}
